import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import { canUserSchedulePost } from 'src/utils/user'
import { ShowSchedulePostModalBtn } from 'src/pages/CommunityDetails/ShowSchedulePostModalBtn'
import { useUser } from 'src/hook/useUser'
import { PostModalFooterProps } from './postModalFooter.types'
import { PostModalFooterContainer } from './postModalFooter.styles'
import { TITLE_MIN_LEN } from './postModalFooter.constants'

const PostModalFooter = ({
  title = '',
  className,
  isFullScreen = false,
  isLoadingSubmit = false,
  onSubmit
}: PostModalFooterProps) => {
  const { permissionsUser } = useUser()

  const canUserCreateSchedulePost =
    permissionsUser?.actions && canUserSchedulePost(permissionsUser.actions)

  return (
    <PostModalFooterContainer $isFullscreen={isFullScreen} className={className}>
      {canUserCreateSchedulePost && <ShowSchedulePostModalBtn isOpen />}

      <Button
        onClick={onSubmit}
        loading={isLoadingSubmit}
        disabled={(title?.trim?.()?.length ?? 0) < TITLE_MIN_LEN}
      >
        {i18n.t('modals.publish_post.buttons.post_create')}
      </Button>
    </PostModalFooterContainer>
  )
}

export default PostModalFooter
